import { render, staticRenderFns } from "./BlanksList.vue?vue&type=template&id=75fa4ab4&scoped=true&"
import script from "./BlanksList.vue?vue&type=script&lang=js&"
export * from "./BlanksList.vue?vue&type=script&lang=js&"
import style0 from "./BlanksList.vue?vue&type=style&index=0&id=75fa4ab4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75fa4ab4",
  null
  
)

export default component.exports